import { render } from "./quotations.vue?vue&type=template&id=364cf27e&scoped=true"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"

import "./quotations.vue?vue&type=style&index=0&id=364cf27e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364cf27e"]])

export default __exports__